export const CompositionFragmentDocumentSymbol = Symbol('CompositionFragmentDocument');

//# sourceMappingURL=document.js.map